export default {
  state: () => ({
    interactionEnabled: false,
  }),
  mutations: {
    setInteractionEnabled(state, count) {
      state.interactionEnabled = count;
    },
  },
  actions: {
    changeInteractionEnabled({ commit, count }) {
      commit("setInteractionEnabled", count);
    },
  },
  getters: {
    getInteractionEnabled(state) {
      return state.interactionEnabled;
    },
  },
};
